import {
	CacheLookupPolicy,
	Configuration,
	InteractionRequiredAuthError,
	LogLevel,
	PublicClientApplication
} from '@azure/msal-browser';

import * as constant from './shared/constants';

const enableLogs = false;
const enableOnlyErrorLogs = true;

const getSignInUrl = () => {
	return constant.getClientUri() + 'signin-oidc';
};

const config: Configuration = {
	auth: {
		authority: `https://login.microsoftonline.com/${constant.getClientTenant()}`,
		clientId: constant.getClientId(),
		redirectUri: getSignInUrl(),
		navigateToLoginRequestUrl: true,
		knownAuthorities: ['login.microsoftonline.com'],
		postLogoutRedirectUri: getSignInUrl()
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: false
	},
	system: {
		loggerOptions: {
			loggerCallback: (
				level: LogLevel,
				message: string,
				containsPii: boolean
			): void => {
				if (containsPii) return;

				switch (level) {
					case LogLevel.Error:
						if (enableOnlyErrorLogs) console.error(message);
						return;

					case LogLevel.Info:
						if (!enableLogs) return;
						console.info(message);
						return;

					case LogLevel.Verbose:
						if (!enableLogs) return;
						console.debug(message);
						return;

					case LogLevel.Warning:
						if (!enableLogs) return;
						console.warn(message);
						return;
				}
			},
			piiLoggingEnabled: false
		}
	}
};

const request = {
	scopes: ['User.Read']
};

export const authProvider = new PublicClientApplication(config);

export async function getAuthorizationToken() {
	const accounts = authProvider
		.getAllAccounts()
		.filter((acc) => acc.idTokenClaims?.tid === constant.getClientTenant());

	if (!accounts || accounts.length <= 0) {
		reAuthenticate();
		return;
	}

	const selectedAccount = accounts[0];

	if (!selectedAccount) {
		reAuthenticate();
		return;
	}

	try {
		const response = await authProvider.acquireTokenSilent({
			scopes: ['User.Read'],
			account: selectedAccount,
			forceRefresh: false,
			cacheLookupPolicy: CacheLookupPolicy.Default
		});

		return response.idToken;
	} catch (error) {
		if (error instanceof InteractionRequiredAuthError) {
			authProvider.acquireTokenRedirect(request);
		} else {
			console.error('Token acquisition failed.');
			authProvider.loginRedirect();
		}
	}
}

export const getUserAccount = () => {
	const account: any = authProvider.getActiveAccount();

	return account;
};

export const reAuthenticate = () => {
	localStorage.clear();
	authProvider.acquireTokenRedirect({
		scopes: ['User.Read'],
		prompt: 'select_account'
	});
};
